import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';
import {debounce} from '../utils/_debounce';

import 'core-js/es6/number';

var $ = jQuery;

export default class PostSlider extends Module {

	ready(app) {    
        
        const SLIDERS = document.querySelectorAll('.mtt-post-slider');

		if (SLIDERS) {
            for (let i = 0; i < SLIDERS.length; i++) {
                const SLIDER_CONTAINER = SLIDERS[i];

                this.SWIPER = new Swiper(SLIDER_CONTAINER.querySelector('.swiper-container'), { 
                    spaceBetween: 27,
                    slidesPerView: 1,
                    breakpoints: {                                                            
                        650: {
                            slidesPerView: 2,
                        },
                        1100: {
                          slidesPerView: 3,
                        },
                        1400: {
                            slidesPerView: 4,
                        }
                    },
                    navigation: {
                      nextEl: SLIDER_CONTAINER.querySelector('.mtt-post-slider__arrow.arrow-right'),
                      prevEl: SLIDER_CONTAINER.querySelector('.mtt-post-slider__arrow.arrow-left'),
                    },                           
                });
    
                this.toggleArrows(SLIDER_CONTAINER); 
    
                window.addEventListener('resize', debounce(() => {
                    this.toggleArrows(SLIDER_CONTAINER);     
                }, 200));
                
            }
        }

    }

    toggleArrows(sliderContainer) {
        if (this.SWIPER.isBeginning && this.SWIPER.isEnd) {
            sliderContainer.querySelector('.mtt-post-slider__arrows').classList.add('hide');
        } else {
            sliderContainer.querySelector('.mtt-post-slider__arrows').classList.remove('hide');
        }   
    }
}